//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'MedicalSections',
    data: () => ({
        medicalSections: [],
        medicalSectionsList: [],
        active: 0
    }),

    async fetch() {
        const response = await this.$api.fetchMedicalSections()
        this.medicalSections = response.content
        if (this.medicalSections) {
            var perChunk = 5
            var result = this.medicalSections.data.reduce((resultArray, item, index) => {
                const chunkIndex = Math.floor(index / perChunk)
                if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = []
                }
                resultArray[chunkIndex].push(item)
                return resultArray
            }, [])
            this.medicalSectionsList = result
        }
    },
}
